import type { ComponentProps } from 'react';
import { css, keyframes, styled } from 'styled-components';

import { Button } from '#/components/Button/Button';
import { colors, spacing } from '#/theme/theme';

const aSlideLTRBackground = keyframes`
  from {
    clip-path: inset(0 100% 0 0);
  }
  to {
    clip-path: inset(0 0 0 0);
  }
`;
type SubmissionsButtonProps = ComponentProps<typeof Button>;

export const SubmissionsButton = styled(Button)<SubmissionsButtonProps>`
  background-color: ${colors.selectionGrey} !important;
  border: none;
  color: ${colors.mediumContentGrey} !important;
  line-height: 1;
  height: 39px;
  position: relative;
  overflow: hidden;
  transition: clip-path;

  > div {
    align-items: center;
    gap: ${spacing[6]};
  }

  &::after {
    align-items: center;
    background-color: ${colors.brandGreen};
    clip-path: inset(0 100% 0 0);
    color: white;
    display: flex;
    justify-content: center;
    content: 'Submissions';
    height: 100%;
    position: absolute;
    width: 100%;
    top: 0;
    right: 0;

    ${(props) =>
      props.variant !== 'inactive'
        ? css`
            animation: ${aSlideLTRBackground} 1s forwards;
          `
        : undefined}
  }

  &:hover {
    color: ${colors.brandGreen} !important;
  }

  &:disabled {
    opacity: 1;
    overflow: visible;

    &:hover {
      color: initial !important;
    }
  }
`;
